//imports
import {
    DEVICES_COMMON_SEARCH_DEVICES,
    DEVICES_COMMON_SEARCH_DEVICES_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    devices: [],
    error: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DEVICES_COMMON_SEARCH_DEVICES:
            return { ...state, loading: true };
            
        case DEVICES_COMMON_SEARCH_DEVICES_RESULT:
            return { ...state, loading: false, devices: action.payload.data.data, error: action.payload.error };

        case CLEAR_REDUX:
            return ["", "DEVICES_COMMON"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
